import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "footer__box__content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "footer__box__content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "footer__box__content" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "w-full flex sm:flex-col sm:items-center md:justify-between md:items-center" }
const _hoisted_8 = { class: "flex h-full sm:w-full" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, "/", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", { class: "md:hidden" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactHeader = _resolveComponent("ContactHeader")!
  const _component_AOS = _resolveComponent("AOS")!
  const _component_Anchor = _resolveComponent("Anchor")!
  const _component_Paragraph = _resolveComponent("Paragraph")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_SocialMediaButton = _resolveComponent("SocialMediaButton")!
  const _component_Container = _resolveComponent("Container")!
  const _component_ThemeChanger = _resolveComponent("ThemeChanger")!
  const _directive_aos_anchor = _resolveDirective("aos-anchor")!

  return (_openBlock(), _createBlock(_component_ThemeChanger, {
    to: _ctx.Theme.Dark
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Container, {
        fluid: "",
        class: "pt-16 md:pt-48 sm:pb-16 font-body"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AOS, {
            type: "fade",
            easing: "ease",
            duration: "400"
          }, {
            default: _withCtx(() => [
              (!_ctx.isContactPage)
                ? _withDirectives((_openBlock(), _createBlock(_component_ContactHeader, {
                    key: 0,
                    class: "mb-20 md:mb-48",
                    heading: _ctx.cms.heading,
                    label: _ctx.cms.contact_us_label,
                    route: _ctx.Route.Contact
                  }, null, 8, ["heading", "label", "route"])), [
                    [_directive_aos_anchor, void 0, "footer-title"]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Grid, { fluid: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_AOS, {
                order: 1,
                anchor: "footer-title",
                "anchor-placement": "top-center",
                step: 150
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    span: 2,
                    class: "footer__box --side"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_Anchor, {
                          underlined: "",
                          "show-arrow": "",
                          route: _ctx.Route.WhatWeDo
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", {
                              innerHTML: _ctx.cms.sub_heading_1
                            }, null, 8, _hoisted_2)
                          ]),
                          _: 1
                        }, 8, ["route"]),
                        _createVNode(_component_Paragraph, {
                          class: "mt-12 md:pr-8",
                          innerHTML: _ctx.cms.sub_paragraph_1
                        }, null, 8, ["innerHTML"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_AOS, {
                order: 2,
                anchor: "footer-title",
                "anchor-placement": "top-center",
                step: 150
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    span: 2,
                    class: "footer__box --middle"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_Anchor, {
                          underlined: "",
                          "show-arrow": "",
                          route: _ctx.Route.About
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", {
                              innerHTML: _ctx.cms.sub_heading_2
                            }, null, 8, _hoisted_4)
                          ]),
                          _: 1
                        }, 8, ["route"]),
                        _createVNode(_component_Paragraph, {
                          class: "mt-12 md:pr-8",
                          innerHTML: _ctx.cms.sub_paragraph_2
                        }, null, 8, ["innerHTML"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_AOS, {
                order: 2,
                anchor: "footer-title",
                "anchor-placement": "top-center",
                step: 150
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    span: 2,
                    class: "footer__box --side"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_Anchor, {
                          underlined: "",
                          "show-arrow": "",
                          route: _ctx.Route.Contact
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", {
                              innerHTML: _ctx.cms.sub_heading_3
                            }, null, 8, _hoisted_6)
                          ]),
                          _: 1
                        }, 8, ["route"]),
                        _createVNode(_component_Paragraph, {
                          class: "mt-12 md:pr-8",
                          innerHTML: _ctx.cms.sub_paragraph_3
                        }, null, 8, ["innerHTML"]),
                        _createElementVNode("div", null, [
                          _createVNode(_component_Anchor, {
                            underlined: "",
                            class: "mt-4",
                            "mail-to": "",
                            route: _ctx.cms.email
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.cms.email), 1)
                            ]),
                            _: 1
                          }, 8, ["route"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Grid, { fluid: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                class: "footer__social",
                container: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialMedia, (social, index) => {
                        return (_openBlock(), _createBlock(_component_SocialMediaButton, _mergeProps({ key: index }, social, {
                          class: "footer__social__icon",
                          large: ""
                        }), null, 16))
                      }), 128))
                    ]),
                    _createVNode(_component_Paragraph, { class: "text-2xs md:text-xs sm:pt-12 sm:text-center text-gray-300 md:mr-14" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Digital Creative Asia 墨山网络科技（上海）有限公司 "),
                        _hoisted_9,
                        _hoisted_10,
                        _createTextVNode(" 沪ICP备19005446号-1 ")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["to"]))
}